import axios, { type AxiosError } from 'axios'

const BASE_URL    = import.meta.env.VITE_API_BASE_URL  ?? 'http://localhost:5000'
const ADMIN_KEY   = import.meta.env.VITE_ADMIN_API_KEY ?? ''

export const adminClient = axios.create({
  baseURL: BASE_URL,
  timeout: 120_000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...(ADMIN_KEY ? { 'X-Admin-Key': ADMIN_KEY } : {}),
  },
})

adminClient.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    const body = err.response?.data as Record<string, unknown> | null
    const msg  = typeof body?.error === 'string' ? body.error
               : typeof body?.message === 'string' ? body.message
               : err.message

    return Promise.reject(new Error(msg))
  },
)
